import React, { useState, useEffect, useContext } from "react";
export default function SearchPage(props) {
  useEffect(() => {
    console.log("SearchPage On mount :", props);
  }, []);
  return (
    <div>
     <div className="sidebar">
	<div className="sidebar-header text-center">
		<div className="d-flex align-items-center justify-content-center mb-2">
			{/* <a className="sidebar-brand link-loader d-inline-flex align-items-center" href="https://1superapp.com/demo2">
								
							</a> */}
		</div>
		<h6 className="mb-1"><a className="sidebar-username" href="https://1superapp.com/demo2">Demo 2</a></h6>
		<p className="mb-0"><a className="sidebar-username" href="https://1superapp.com/demo2">@demo2</a></p>
	</div>
	<div className="sidebar-sticky">
    	<ul>
    		{/* <li><a className="link-loader" href="https://1superapp.com/dashboard"><i className="material-icons ml-auto">house</i> <span>Dashboard</span></a></li>
			<li><a className="link-loader" href="https://1superapp.com/organization"><i className="material-icons ml-auto">groups</i> <span>Organizations</span></a></li>
			<li><a className="link-loader" href="https://1superapp.com/invite"><i className="material-icons ml-auto">share</i> <span>Invite Friends</span></a></li>
						<li><a className="link-loader" href="https://1superapp.com/settings"><i className="material-icons ml-auto">settings</i> <span>Settings</span></a></li>
            <li><a className="link-loader" href="https://1superapp.com/contact"><i className="material-icons ml-auto">phone</i> <span>Contact</span></a></li>
			<li><a className="" href="https://1superapp.com/about"><i className="material-icons ml-auto">info</i> <span>About</span></a></li> */}
    	</ul>
		<div className="sidebar-footer text-center">
			{/* <a className="text-dark text-decoration-none text-uppercase" target="_blank" href="http://rajarathina.com"><img className="img-fluid" src="https://1superapp.com/assets/images/rajarathina-text-logo-mc.png" width="80"></a> */}
		</div>
	</div>
</div>

<div className="page-content">





<div className="container">
	<div className="row">
		<div className="col-lg-12 mt-1">
			<div className="row">
				<div className="col-4 pp-10 pt-2 ppr-5">
					<a className="text-decoration-none" href="https://1blood.1superapp.com/login">
						<div className="box-2 br-3 p-3 text-center dashboard-btn d-flex justify-content-center align-items-center">
							<div>
								<h6 className="mt-2 text-uppercase text-secondary">Blood</h6>
							</div>
						</div>
					</a>
				</div>
				<div className="col-4 pp-10 pt-2 ppl-5 ppr-5">
					<a className="text-decoration-none" href="https://1studio.1superapp.com/dashboard">
						<div className="box-2 br-3 p-3 text-center dashboard-btn d-flex justify-content-center align-items-center">
							<div>
								<h6 className="mt-2 text-uppercase text-secondary">Studio</h6>
							</div>
						</div>
					</a>
				</div>
				<div className="col-4 pp-10 pt-2 ppl-5">
					<a className="text-decoration-none" href="https://1restaurant.1superapp.com/dashboard">
						<div className="box-2 br-3 p-3 text-center dashboard-btn d-flex justify-content-center align-items-center">
							<div>
								<h6 className="mt-2 text-uppercase text-secondary">Restaurant</h6>
							</div>
						</div>
					</a>
				</div>
				<div className="col-4 pp-10 pt-0 ppr-5">
					<a className="text-decoration-none" href="https://1superapp.com/document_verification">
						<div className="box-2 br-3 p-3 text-center dashboard-btn d-flex justify-content-center align-items-center">
							<div>
								<h6 className="mt-2 text-uppercase text-secondary">Identity</h6>
							</div>
						</div>
					</a>
				</div>
			</div>
		</div>
			</div>
</div>
<div className="checklocation-dashboard"></div>

			</div>
    </div>
  );
}
